import { render, staticRenderFns } from "./SuperBowlExpenses.vue?vue&type=template&id=52fea3a0&scoped=true&"
import script from "./SuperBowlExpenses.vue?vue&type=script&lang=js&"
export * from "./SuperBowlExpenses.vue?vue&type=script&lang=js&"
import style0 from "./SuperBowlExpenses.vue?vue&type=style&index=0&id=52fea3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fea3a0",
  null
  
)

export default component.exports